import { Phone, Mail, MapPin, Facebook, Linkedin, Twitter } from "lucide-react";
import { useNavigate } from "react-router-dom";
export const Footer = () => {
  const navigate = useNavigate();

  const handleSmoothScroll = (targetId: string) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };
  return <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Informations entreprise */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="./images/Logo web outilmatpro.jpg" 
                alt="OutilMatPro Logo" 
                className="h-10 w-auto mr-3"
              />
              <h3 className="text-2xl font-bold text-orange-400">OutilMatPro</h3>
            </div>
            <p className="text-gray-300 mb-4">
              Votre partenaire de confiance pour les outils professionnels de coupe. 
              Spécialiste des disques diamantés pour carreleurs et maçons.
            </p>
            <div className="flex space-x-4">
              <Facebook className="h-5 w-5 text-gray-400 hover:text-orange-400 cursor-pointer" />
              <Linkedin className="h-5 w-5 text-gray-400 hover:text-orange-400 cursor-pointer" />
              <Twitter className="h-5 w-5 text-gray-400 hover:text-orange-400 cursor-pointer" />
            </div>
          </div>

          {/* Nos produits */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Nos Produits</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors">Elite Precision Pro</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Elite Precision Standard</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Elite Precision Biseau</a></li>
              <li><a href="#" className="hover:text-white transition-colors">ElitePro Béton</a></li>
              <li><a href="#" className="hover:text-white transition-colors">ElitePro Universal</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Elite Performance</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li><button onClick={() => handleSmoothScroll('gammes-principales')} className="hover:text-white transition-colors text-left">À propos</button></li>
              <li><a href="#" className="hover:text-white transition-colors">Devis personnalisé</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Support technique</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Formation produits</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Livraison express</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Garantie professionnelle</a></li>
              <li><a href="#" className="hover:text-white transition-colors">SAV dédié</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-orange-400" />
                <span>+33 6 61 01 84 89</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-orange-400" />
                <span>contact@outilmatpro.fr</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-orange-400 mt-1" />
                <div>
                  <div>7 Rue du Général de Monsabert</div>
                  <div>34500 Béziers, France</div>
                </div>
              </div>
            </div>
            
            <div className="mt-6">
              <h5 className="font-semibold mb-2">Horaires d'ouverture</h5>
              <div className="text-sm text-gray-300">
                <div>Lun-Ven : 8h00 - 18h00</div>
                
                
              </div>
            </div>
          </div>
        </div>

        {/* Séparateur */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 OutilMatPro. Tous droits réservés.
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <button onClick={() => navigate('/mentions-legales')} className="hover:text-white transition-colors">Mentions légales</button>
              <button onClick={() => navigate('/cgv')} className="hover:text-white transition-colors">CGV</button>
              <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
              <a href="#" className="hover:text-white transition-colors">Plan du site</a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};